"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  Configurator: true,
  ConfiguratorReducers: true
};
exports.ConfiguratorReducers = exports.Configurator = void 0;
var _configurator = _interopRequireDefault(require("./components/configurator"));
exports.Configurator = _configurator["default"];
var _reducers = require("./reducers");
exports.ConfiguratorReducers = _reducers.ConfiguratorReducers;
var _configurator2 = require("./components/configurator.props/configurator.propTypes");
Object.keys(_configurator2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _configurator2[key]) return;
  exports[key] = _configurator2[key];
});